import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {navigation} from '@app/components-fuse/navigation/navigation';
import {AuthService} from '@app/services/auth/auth.service';
import {environment} from '@environments/environment';
import {FuseSidebarService} from '@fuse/components/sidebar/sidebar.service';
import {FuseConfigService} from '@fuse/services/config.service';
import {UserContext} from '@models/user';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {ChangeLang, LogOut, SWITCH_DISPLAY_KEY_OR_LABEL_MODE, SwitchDebugMode} from '@store/actions/auth.actions';
import {AppState, selectAuthState} from '@store/app.states';
import {State as authState} from '@store/reducers/auth.reducers';
import {find} from 'lodash-es';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FullSearchService} from '../../../../../@shared/_referencesLists/full-search/full-search.service';
import {DisplayStoreTreePopupService} from '@app/4dm1n/store-tree/display-store-tree-popup.service';
import {FirebaseStatusService} from "@app/firebase-status/firebase-status.service";
import {MetaSurveysInfosService} from "@app/services/metas/meta-surveys-infos.service";

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToolbarComponent implements OnInit, OnDestroy {
  getState$: Observable<authState> = this.store.select(selectAuthState);

  baseUrl = environment.legacyBaseUrl;

  userContext: UserContext = this.authService.getContext();

  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  languages = [
    {
      id: 'en',
      title: 'English',
      flag: 'us',
    },
    {
      id: 'fr',
      title: 'Français',
      flag: 'fr',
    },
  ];
  navigation: any;
  selectedLanguage = {
    id: 'fr',
    title: 'Français',
    flag: 'fr',
  };
  userStatusOptions: any[];

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(private store: Store<AppState>,
              private authService: AuthService,
              private _fuseConfigService: FuseConfigService,
              private _fuseSidebarService: FuseSidebarService,
              private _translateService: TranslateService,
              public fullSearchService: FullSearchService,
              public displayStoreTreePopupService: DisplayStoreTreePopupService,
              public firebaseStatusService: FirebaseStatusService,
              public metaSurveysInfosService: MetaSurveysInfosService,

  ) {
    // Set the defaults
    this.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50',
      },
      {
        title: 'Away',
        icon: 'icon-clock',
        color: '#FFC107',
      },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336',
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD',
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161',
      },
    ];

    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to the config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((settings) => {
      this.horizontalNavbar = settings.layout.navbar.position === 'top';
      this.rightNavbar = settings.layout.navbar.position === 'right';

      this.hiddenNavbar = settings.layout.navbar.hidden === true;

    });

    // Set the selected language from default languages
    this.selectedLanguage = find(this.languages, {
      id: this._translateService.currentLang || 'fr',
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   */
  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  /**
   * Search
   *
   */
  search(value): void {
    // Do your search here...
    // console.log(value);
  }

  /**
   * Set the language
   *
   */
  setLanguage(lang: any): void {

    // Set the selected language for the toolbar
    this.selectedLanguage = lang || this.languages[0];
    this.store.dispatch(new ChangeLang({newLang: lang.id}));

  }

  logOut(): void {
    this.store.dispatch(new LogOut());
  }

  switchDebugMode(): void {
    this.store.dispatch(new SwitchDebugMode());
  }

  setMode(mode: 'key' | 'label'): void {
    this.store.dispatch(new SWITCH_DISPLAY_KEY_OR_LABEL_MODE({mode}));
  }
}
